import React from 'react';

import WithImage, { IWithImageProps } from './WithImage';
import WithoutImage, { IWithoutImageProps } from './WithoutImage';

export interface ITwoColViewProps extends IWithImageProps, IWithoutImageProps {
  withoutImage?: boolean;
  showLogo?: boolean;
}

const TwoColView: React.FC<ITwoColViewProps> = ({ withoutImage = false, children, ...rest }) => {
  const Component = withoutImage ? WithoutImage : WithImage;
  return <Component {...rest}>{children}</Component>;
};

export default TwoColView;
